import { Directive } from '@angular/core';

@Directive({
    selector: 'tr[bigUiTableRow]',
    host: {
        class: 'group/row',
    },
})
export class TableRowDirective {
}
